import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import Plant_app from "./trkr_plant/App";
import Contractor_App from "./contractor/App";
import Dir_App from "./plant_dir/App";
import Super_Admin from "./super_admin/App";
import Logistics from "./logistics/App";
import LogisticsReg from "./logisticsRegistration/App";
import RmxReg from "./rmxRegistration/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { Plant_Store } from "./trkr_plant/store";
import { Contractor_Store } from "./contractor/store";
import { Plant_Dir } from "./plant_dir/store";
import { Store } from "./super_admin/store";
import { LogisticsRegStore } from "./logisticsRegistration/store";
import { LogisticsStore } from "./logistics/store";
import { RmxRegStore } from "./rmxRegistration/store";
const subdomain = window.location.host.split(process.env.REACT_APP_DOMAIN)[0];
// const subdomain = window.location.host.split('.localhost:3000')[0];  // for local

const hashLink = window.location?.hash?.split("/")?.[1];
console.log("SUBDOMAIN===>", subdomain);

// ReactDOM.render(
//   <BrowserRouter basename="/#/logistics">
//     <Provider store={LogisticsStore}>
//       <Logistics />
//     </Provider>
//   </BrowserRouter>,
//   document.getElementById("root")
// );

// ReactDOM.render(
//   <BrowserRouter basename="/#/rmx">
//     <Provider store={RmxRegStore}>
//       <RmxReg />
//     </Provider>
//   </BrowserRouter>,
//   document.getElementById("root")
// );

// ReactDOM.render(
//   <BrowserRouter basename="/#/">
//     <Provider store={Plant_Dir}>
//       <Dir_App subdomain={"pm"} />
//     </Provider>
//   </BrowserRouter>,
//   document.getElementById("root")
// );

// ReactDOM.render(
//   <BrowserRouter basename="/#/logistics">
//     <Provider store={LogisticsRegStore}>
//       <LogisticsReg />
//     </Provider>
//   </BrowserRouter>,
//   document.getElementById("root")
// );

// ReactDOM.render(
//   <BrowserRouter basename="/#/admin">
//     <Provider store={Store}>
//       <Super_Admin />
//     </Provider>
//   </BrowserRouter>,
//   document.getElementById("root")
// );
// ReactDOM.render(
//   <BrowserRouter basename="/#/customer">
//     <Provider store={Contractor_Store}>
//       <Contractor_App />
//     </Provider>
//   </BrowserRouter>,
//   document.getElementById("root")
// );

// ReactDOM.render(
//   <BrowserRouter
//     basename={
//       hashLink === "manage"
//         ? `/#/plant/dashboard?code=${window?.location?.hash?.split("code=")?.[1]}`
//         : "/#/plant"
//     }
//   >
//     <Provider store={Plant_Store}>
//       <Plant_app subdomain={'pm'} />
//     </Provider>
//   </BrowserRouter>,
//   document.getElementById("root")
// )

if (
  hashLink === "" ||
  hashLink === "product" ||
  hashLink === undefined ||
  hashLink === "aboutus"
) {
  ReactDOM.render(
    <BrowserRouter basename="/#/">
      <Provider store={Plant_Dir}>
        <Dir_App subdomain={subdomain} />
      </Provider>
    </BrowserRouter>,
    document.getElementById("root")
  );
} else if (subdomain === "app") {
  const hashName = window.location.hash.split("/")[1];
  if (hashName === "logistics") {
    ReactDOM.render(
      <BrowserRouter basename="/#/logistics">
        <Provider store={LogisticsRegStore}>
          <LogisticsReg />
        </Provider>
      </BrowserRouter>,
      document.getElementById("root")
    );
  } else if (hashName === "rmx") {
    ReactDOM.render(
      <BrowserRouter basename="/#/rmx">
        <Provider store={RmxRegStore}>
          <RmxReg />
        </Provider>
      </BrowserRouter>,
      document.getElementById("root")
    );
  } else if (hashName === "customer") {
    ReactDOM.render(
      <BrowserRouter basename="/#/customer">
        <Provider store={Contractor_Store}>
          <Contractor_App />
        </Provider>
      </BrowserRouter>,
      document.getElementById("root")
    );
  } else if (hashName === "admin") {
    ReactDOM.render(
      <BrowserRouter basename="/#/admin">
        <Provider store={Store}>
          <Super_Admin />
        </Provider>
      </BrowserRouter>,
      document.getElementById("root")
    );
  }
} else if (subdomain === "logistics") {
  ReactDOM.render(
    <BrowserRouter basename="/#/logistics">
      <Provider store={LogisticsStore}>
        <Logistics />
      </Provider>
    </BrowserRouter>,
    document.getElementById("root")
  );
} else if (hashLink == "plant" || hashLink == "manage") {
  ReactDOM.render(
    <BrowserRouter
      basename={
        hashLink === "manage"
          ? `/#/plant/dashboard?code=${window?.location?.hash?.split("code=")?.[1]}`
          : "/#/plant"
      }
    >
      <Provider store={Plant_Store}>
        <Plant_app subdomain={subdomain} />
      </Provider>
    </BrowserRouter>,
    document.getElementById("root")
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// serviceWorker.register()
